export default __webpack_public_path__ + "static/Prostatizal-mobile-ccaf64d721e6125bcbf1857e94387fb5.jpg";